import React, { useEffect, useRef, useState } from "react";
import { useThemeColor } from "../Components/Sidebar/SideBarApi";
import { DatePicker, Space } from "antd";
import { formBtn1, formBtn2, pageClass, pageHeader} from "../Components/Utils/CustomClasses";
import Table from "../Components/Table/Table";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { AssignUserAPI, getAllTeamAttendence } from "../API/Api";
import usePaginatedData from "../Components/Utils/UsePagination";
import moment from "moment";
import Select from "react-select";
import { customStyles} from "../Components/Utils/CommonFuntion";
import ButtonLoader from "../Components/Loader/ButtonLoader";

export default function TeamAttendence() {

  const { register, control,reset, handleSubmit, formState: { errors },} = useForm();
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const filterTimeout = useRef();
  const isFirstRender = useRef(true);
  const themeColor = useThemeColor();
  const [loader, setLoader] = useState(false); 
  const [assignUsers, setAssignUsers] = useState([]);
  const { RangePicker } = DatePicker;
  

  const initialFilterState = { p: 1, userId: userDetails?._id || "", companyId: userDetails?.role?.roleName !== "SuperAdmin"  ? userDetails?.company?._id : "",};

  const assignToOptions =
    assignUsers != undefined
      ? assignUsers.map((user) => ({
          value: user?._id,
          label: `${user?.first_name} ${user?.last_name} - ${user?.role?.roleName}`,
        }))
      : [{ value: "", label: "No data found" }];

  const [filterObject, setFilterObject] = useState({ ...initialFilterState });
  const { filterData: AttendenceData, pageNo, nextIsValid, prevIsValid, pageChangeHandler, recordChangeHandler, fetchData } = usePaginatedData(1, 50, getAllTeamAttendence, filterObject);
 
  let timeoutId;
  const fetchUsers = async (selectedOption) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout( async () => {
    const payload = {
      id: userDetails?._id,
      role: userDetails?.role?.roleName,
      search: selectedOption,
      company:
        userDetails?.role?.roleName === "SuperAdmin"
          ? ""
          : userDetails?.company?._id,
    };
    try {
      let response = await AssignUserAPI(payload);
      setAssignUsers(response?.data?.filteredData);
    } catch (err) {
      console.log("Error fetching users:", err);
    }
  }, 1500)};

  useEffect(() => {
    fetchUsers();
  }, []);

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      try {
        await fetchData({ ...filterObject });
      } finally {
        setLoader(false);
        filterTimeout.current = null;
      }
    }, 1500);
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Prevent first API call from `useEffect`
      return;
    }
    filterRecords();
  }, [filterObject]);

  const getBreakDuration = (inTime, outTime) => {
    if (!inTime || !outTime) return null;

    const inMoment = moment(inTime, "h:mm A");
    const outMoment = moment(outTime, "h:mm A");
    const duration = moment.duration(outMoment.diff(inMoment));
    const minutes = duration.asMinutes();

    return minutes > 0 ? `${Math.floor(minutes)} mins` : "0 mins";
  };

  const tableColumns = [
    {
      field: "first_name",
      header: "First Name",
      style: true,
      body: (row) => (
        <h6>{row?.userId?.first_name ? row?.userId?.first_name : "------"}</h6>
      ),
    },
    {
      field: "last_name",
      header: "Last Name",
      style: true,
      body: (row) => (
        <h6>{row?.userId?.last_name ? row?.userId?.last_name : "------"}</h6>
      ),
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => (
        <h6>{row?.userId?.email ? row?.userId?.email : "------"}</h6>
      ),
    },
    {
      field: "date",
      header: "Date",
      style: true,
      body: (row) => (
        <h6> {moment(row.date).format("DD-MM-YYYY") ? moment(row.date).format("DD-MM-YYYY") : "-----"} </h6>
      ),
    },
    {
      field: "inTime",
      header: "In Time",
      style: true,
      body: (row) => <h6>{row?.inTime ? row?.inTime : "----"}</h6>,
    },
    {
      field: "outTime",
      header: "Out Time",
      style: true,
      body: (row) => <h6>{row?.outTime ? row?.outTime : "-----"}</h6>,
    },
    {
      field: "breakTime",
      header: "Break Time",
      style: true,
      body: (row) => (
        <h6>
          {row?.break === true ? getBreakDuration(row?.inTime, row?.outTime) || "-----" : "-----"}
        </h6>
      ),
    },
    {
      field: "break_type",
      header: "Break Type",
      style: true,
      body: (row) => <h6>{row?.break_type ? row?.break_type : "------"}</h6>,
    },
    {
      field: "remark",
      header: "Remark",
      style: true,
      body: (row) => <h6>{row?.remark ? row?.remark : "------"}</h6>,
    },
    {
      field: "comment",
      header: "Comment",
      style: true,
      body: (row) => <h6>{row?.comment ? row?.comment : "-----"}</h6>,
    },
  ];

  const filterSubmit = async (data) =>{
    setLoader(true);
    let startDateFormatted = "";
    let endDateFormatted = "";
    if (data?.rangeDate != undefined && data?.rangeDate?.length != 0) {
      const startDate = `${data?.rangeDate[0].$D}-${ data?.rangeDate[0].$M + 1 }-${data?.rangeDate[0].$y}`;
      const endDate = `${data?.rangeDate[1].$D}-${data?.rangeDate[1].$M + 1}-${data?.rangeDate[1].$y}`;
      startDateFormatted = moment(startDate, "DD-MM-YYYY").format("DD-MM-YYYY");
      endDateFormatted = moment(endDate, "DD-MM-YYYY").format("DD-MM-YYYY");
    }

    const payload = {
      ...filterObject,
      user: data?.userId?.value,
      startDate: startDateFormatted,
      endDate: endDateFormatted
    }

    setFilterObject(payload);
  }

  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader}`}>Team Attendance </h1>
          </div>
          <form
            onSubmit={handleSubmit(filterSubmit)}
            className="flex flex-col lg:flex-row gap-3 mt-4"
          >
            {/* FILTERS */}
            <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
              {/* Date Range */}
              <div className="w-full">
                <Space direction="vertical" size={12} className="w-full">
                  <Controller
                    name="rangeDate"
                    control={control}
                    render={({ field }) => (
                      <RangePicker
                        {...field}
                        className="w-full h-[48px] rounded-lg border border-[#DFDFDF] bg-[#F9FAFB] px-3 shadow-none hover:shadow-none focus:shadow-none"
                      />
                    )}
                  />
                </Space>
              </div>

              {/* User Select */}
              <div>
                <Controller
                  name="userId"
                  control={control}
                  render={({ field }) => (
                    <Select
                      value={field.value || null}
                      options={assignToOptions}
                      placeholder="Select User"
                      styles={customStyles}
                      maxMenuHeight={220}
                      menuPlacement="auto"
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption);
                        fetchUsers(selectedOption);
                      }}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") {
                          fetchUsers(inputValue);
                        }
                      }}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>

            {/* BUTTONS */}
            <div className="flex gap-2 justify-end flex-shrink-0 items-center">
              {loader ? (
                <ButtonLoader />
              ) : (
                <button type="submit" className={`${formBtn1}`}>
                  Apply
                </button>
              )}

              <button
                type="button"
                onClick={() => {
                  reset({ userId: null, rangeDate: null });
                  setFilterObject(initialFilterState);
                }}
                className={`${formBtn2}`}
              >
                Clear
              </button>
            </div>
          </form>
          <div className="mt-4">
            <Table
              columns={tableColumns}
              data={AttendenceData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
            />
          </div>
        </div>
      </div>
    </>
  );
}